import { Redirect, Route, useHistory } from "react-router-dom";
import useLocalStorage from "react-use-localstorage";
import { AppRoute } from "enums/appRoute";
import jwt_decode, { JwtPayload } from "jwt-decode";
import { compareAsc, getUnixTime } from "date-fns";

export const AuthorizedRoute = (props: any) => {
  const [token] = useLocalStorage("token");
  const history = useHistory();

  if (!token)
    return (
      <Redirect
        to={{
          pathname: AppRoute.LOGIN,
          state: {
            cardId: history.location.pathname.split("/")[2],
            type: history.location.pathname.split("/")[1],
          },
        }}
      />
    );

  const decoded = jwt_decode<JwtPayload>(token, {});
  const validToken = compareAsc(decoded.exp || 0, getUnixTime(new Date()));

  if (validToken !== 1) {
    localStorage.clear();
    return (
      <Redirect
        to={{
          pathname: AppRoute.LOGIN,
          state: {
            cardId: history.location.pathname.split("/")[2],
            type: history.location.pathname.split("/")[1],
          },
        }}
      />
    );
  }

  return <Route {...props} />;
};
